module.exports = __webpack_public_path__ + "img/alerts-6.ca1f3034.gif";